import { render, staticRenderFns } from "./TFloatSaveButton.vue?vue&type=template&id=35fc1ee0&scoped=true&"
import script from "./TFloatSaveButton.vue?vue&type=script&lang=ts&"
export * from "./TFloatSaveButton.vue?vue&type=script&lang=ts&"
import style0 from "./TFloatSaveButton.vue?vue&type=style&index=0&id=35fc1ee0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35fc1ee0",
  null
  
)

export default component.exports